import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 800,
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const Audit = ({ handleClose, audit, open }) => {
  const url = process.env.REACT_APP_URL;
  const { t } = useTranslation();
  const [localAud, setLocalAud] = useState({});

  useEffect(() => {
    if (open) {
      setLocalAud({});
      const timeout = setTimeout(() => {
        setLocalAud(audit);
      }, 60000);
      return () => clearTimeout(timeout);
    }
  }, [open, audit]);

  const closeModal = () => {
    setLocalAud(null);
    handleClose(false);
  };

  const sendEmail = async () => {
    try {
      await axios.post(`${url}/audit/send-individual-audit-email`, {
        audit: audit,
        email: JSON.parse(localStorage.getItem("user")).email,
      });
    } catch {
      alert(t("email_fail"));
    }
  };

  return (
    <Box sx={style}>
      {Object.keys(localAud).length === 0 ? (
        <div className="loader">
          <p>{t("loading_info")}</p>
          <div className="spinner"></div>
        </div>
      ) : (
        <>
          <Typography
            id="instructions-modal-title"
            variant="h6"
            component="h2"
            gutterBottom
          >
            {localAud[0].business}
          </Typography>

          <table className="summaryTable">
            <thead>
              <tr>
                <th>{t("business")}</th>
                <th>{t("phone")}</th>
                <th>{t("performance")}</th>
                <th>{t("accessibility")}</th>
                <th>{t("best_practices")}</th>
                <th>{t("seo")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{localAud[0].business}</td>
                <td>{localAud[0].phone}</td>
                <td>{localAud[0].scores.performance}</td>
                <td>{localAud[0].scores.accessibility}</td>
                <td>{localAud[0].scores.bestPractices}</td>
                <td>{localAud[0].scores.seo}</td>
              </tr>
            </tbody>
          </table>

          <Typography variant="body1" gutterBottom>
            {localAud[0].summary
              .split("\n\n")
              .filter((block) => block.trim() !== "")
              .map((block, i) => (
                <p key={i}>{block}</p>
              ))}
          </Typography>

          {/* 🔧 Tech Stack Section */}
          {localAud[0].techStack && localAud[0].techStack.length > 0 && (
            <Box sx={{ mt: 3 }}>
              <Typography
                variant="body2"
                sx={{ fontStyle: "italic", mb: 1, color: "text.secondary" }}
              >
                {t(
                  "Technology Disclaimer: The technologies listed below were detected on this website, but the list may not be exhaustive. For a more comprehensive overview, consider using a tool like Wappalyzer."
                ) || "Detected technologies (not exhaustive):"}
              </Typography>
              <Typography variant="body2">
                {localAud[0].techStack
                  .map((tech, index) => tech.name)
                  .join(", ")}
              </Typography>
            </Box>
          )}

          <Box sx={{ textAlign: "right", mt: 3 }}>
            <Button variant="contained" color="primary" onClick={sendEmail}>
              {t("email_result") || "Email Result"}
            </Button>
            <Button
              sx={{ ml: 3 }}
              variant="contained"
              color="error"
              onClick={closeModal}
            >
              {t("close") || "Close"}
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default Audit;
